import React, {useContext, useEffect} from "react";
import {AxiosError} from "axios";

// Components
import SliderFeaturedContent from "../../../Components/Layouts/Content/SliderFeaturedContent";
import CarouselLandscape from "../../../Components/Layouts/Content/Carousels/CarouselLandscape";
import CarouselPortrait from "../../../Components/Layouts/Content/Carousels/CarouselPortrait";
import PortraitPresenterItem from "../../../Components/Layouts/Content/Watch/Series/PortraitPresenterItem";

// Hooks
import useFetchCoreCollection from "../../../Hooks/Content/Watch/Series/useFetchCoreCollection";
import useFetchVideosBySeries from "../../../Hooks/Content/Watch/VideoFeed/useFetchVideosBySeries";

// Context
import {UserAuthenticationContext} from "../../../Context/UserAuthenticationContext";

// Constants
import {RoutePaths} from "../../../Constants/RoutePaths";

// Api
import {GetNewAndCurrentAffairs} from "../../../Api/Carousel";

function WeeklyShows() {
    const
        {userData} = useContext(UserAuthenticationContext),
        { items: presenters, loading: presentersLoading } = useFetchCoreCollection(),
        {
            content: gitContent,
            loading: gitLoading
        } = useFetchVideosBySeries(148, 12, 0, "desc", true),
        {
            content: classifiedContent,
            loading: classifiedLoading
        } = useFetchVideosBySeries(150, 12, 0, "desc", true),
        {
            content: messengersContent,
            loading: messengersLoading
        } = useFetchVideosBySeries(106, 12, 0, "desc", true),
        {
            content: wtafContent,
            loading: wtafLoading
        } = useFetchVideosBySeries(107, 12, 0, "desc", true),
        {
            content: wakeUpCallContent,
            loading: wakeUpCallLoading
        } = useFetchVideosBySeries(182, 12, 0, "desc", true),
        {
            content: bringTheFireContent,
            loading: bringTheFireLoading
        } = useFetchVideosBySeries(187, 12, 0, "desc", true),
        {
            content: legacyContent,
            loading: legacyLoading
        } = useFetchVideosBySeries(192, 12, 0, "desc", true),
        {
            content: roundTableContent,
            loading: roundTableLoading
        } = useFetchVideosBySeries(193, 12, 0, "desc", true),
        {
            content: everythingContent,
            loading: everythingLoading
        } = useFetchVideosBySeries(194, 12, 0, "desc", true),
        {
            content: focusContent,
            loading: focusLoading
        } = useFetchVideosBySeries(197, 12, 0, "desc", true),
        {
            content: askDavidContent,
            loading: askDavidLoading
        } = useFetchVideosBySeries(198, 12, 0, "desc", true),
        {
            content: burningQuestionsContent,
            loading: burningQuestionsLoading
        } = useFetchVideosBySeries(200, 12, 0, "desc", true);

    useEffect(() => {
        const func = async () => {
            const newsData = await GetNewAndCurrentAffairs("387c51a3-5aa1-4f2e-9286-487d72895a1e");
            if (newsData && !(newsData instanceof AxiosError) && newsData.Content && newsData.Content.length > 0) {
                console.log(newsData);
            }
        }

        //func();
    }, []);

    return (
        <>
            <SliderFeaturedContent
                sliderId={6}
                classNameInner="front-page"
                userDetails={userData}
            />

            <div className="page page--weekly-shows">
                <div className="page__carousel-container">
                    <CarouselPortrait
                        heading="Weekly Shows"
                        isDarkMode={true}
                        carouselItems={presentersLoading ? undefined : presenters}
                        renderItem={
                            (item, isItemLoading) => (
                                <PortraitPresenterItem
                                    item={item}
                                    isLoading={isItemLoading}
                                />
                            )
                        }
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Gareth Icke Tonight"
                        isDarkMode={true}
                        carouselItems={gitLoading ? undefined : gitContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(148)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Classified with Richard Willett"
                        isDarkMode={true}
                        carouselItems={classifiedLoading ? undefined : classifiedContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(150)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Messengers with Christianne van Wijk"
                        isDarkMode={true}
                        carouselItems={messengersLoading ? undefined : messengersContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(106)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="WTAF With Rich & Gaz"
                        isDarkMode={true}
                        carouselItems={wtafLoading ? undefined : wtafContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(107)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Wake Up Call with Kristen Bitting"
                        isDarkMode={true}
                        carouselItems={wakeUpCallLoading ? undefined : wakeUpCallContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(182)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Bring The Fire with Gareth Icke"
                        isDarkMode={true}
                        carouselItems={bringTheFireLoading ? undefined : bringTheFireContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(187)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="The Legacy"
                        isDarkMode={true}
                        carouselItems={legacyLoading ? undefined : legacyContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(192)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="The Round Table"
                        isDarkMode={true}
                        carouselItems={roundTableLoading ? undefined : roundTableContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(193)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Everything Answered"
                        isDarkMode={true}
                        carouselItems={everythingLoading ? undefined : everythingContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(194)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Focus with Richard Willett"
                        isDarkMode={true}
                        carouselItems={focusLoading ? undefined : focusContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(197)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Ask David"
                        isDarkMode={true}
                        carouselItems={askDavidLoading ? undefined : askDavidContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(198)}
                    />
                </div>

                <div className="page__carousel-container">
                    <CarouselLandscape
                        heading="Burning Questions"
                        isDarkMode={true}
                        carouselItems={burningQuestionsLoading ? undefined : burningQuestionsContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.SeriesEpisodes(200)}
                    />
                </div>
            </div>
        </>
    );
}

export default WeeklyShows;
